import { render, staticRenderFns } from "./products-search.modal.vue?vue&type=template&id=101dd895&scoped=true&"
import script from "./products-search.modal.vue?vue&type=script&lang=ts&"
export * from "./products-search.modal.vue?vue&type=script&lang=ts&"
import style0 from "./products-search.modal.vue?vue&type=style&index=0&id=101dd895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101dd895",
  null
  
)

export default component.exports